import { hdrm } from '@yola/ws-sdk';
import customTools from '../../custom-tools';
import { EXTENSION } from '../constants/item-types';

const { text } = hdrm.injections.bindings;

const exceptions = [];

const shouldItemBeAutoActivated = (itemToActivate, targetElement, sameBoundsElements) => {
  if (exceptions.includes(itemToActivate.id)) {
    return false;
  }

  if (text.getRootTextElement(targetElement)) {
    return false;
  }

  const hasMatchedCustomTool = sameBoundsElements.some(
    ({ element: sameBoundsElement }) => customTools.filters.findAllFor(sameBoundsElement).length
  );

  if (hasMatchedCustomTool) {
    return false;
  }

  return itemToActivate.type === EXTENSION;
};

export default shouldItemBeAutoActivated;
